export default __webpack_public_path__ + "static/media/banner.e859cdfa.jpg";